module.exports = __webpack_public_path__ + "static/media/menuList-bg-shape.b99bedc6.svg";